// assets
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import { PO_URL } from 'apis/apiConfig';
import { ReactComponent as IconEmployee } from 'assets/images/icons/employee.svg';
import { ReactComponent as IconDocument } from 'assets/images/icons/document.svg';

// constant
const icons = {
	IconEmployee,
	IconDocument
};

// ==============================|| ORGANIZATION MENU ITEMS ||============================== //

const organization = {
	id: 'organization',
	title: 'Organization',
	type: 'group',
	children: [
		{
			id: 'employees',
			title: 'Users',
			type: 'item',
			url: '/employees',
			icon: icons.IconEmployee,
			breadcrumbs: true,
		},
		{
			id: 'loansStatus',
			title: 'Loans Status',
			type: 'item',
			url: '/loansStatus',
			icon: icons.IconDocument,
			breadcrumbs: true,
		},
		{
			id: 'products',
			title: 'Products',
			type: 'item',
			url: '/products',
			icon: Inventory2OutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'workflows',
			title: 'Workflows',
			type: 'item',
			url: '/workflows',
			icon: SchemaOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'auditLogs',
			title: 'Audit Logs',
			type: 'item',
			url: '/audit-logs',
			icon: SchemaOutlinedIcon,
			breadcrumbs: true,
		},
		// {
		// 	id: 'partnerOnboarding',
		// 	title: 'Partner Onboarding',
		// 	type: 'item',
		// 	url: PO_URL,
		// 	icon: SchemaOutlinedIcon,
		// 	target: true,
		// },
		{
			id: 'ruleGroups',
			title: 'Rule Groups',
			type: 'item',
			url: '/ruleGroups',
			icon: SchemaOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'partnerRuleGroups',
			title: 'Partner Rule Groups',
			type: 'item',
			url: '/partnerRuleGroups',
			icon: SchemaOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'product_features',
			title: 'Product features',
			type: 'collapse',
			icon: SchemaOutlinedIcon,
			children: [
				{
					id: 'customerNotification',
					title: 'Customer Notifications',
					type: 'item',
					url: '/customerNotifications',
					icon: Inventory2OutlinedIcon,
					breadcrumbs: true,
				},
			],
		},
	],
};

export default organization;
